import type { FixedPerUnitProduct } from '../../../../../products-filter/products-filter-types/pricing-product';
import type { FixedProductPriceEstimator } from '../../index';
import { FIXED_PER_UNIT_PRICE_ESTIMATOR_DEFAULT_CONTRACT_DURATION } from './fixed-per-unit-price-estimator-default-contract-duration';

export class FixedPerUnitPriceEstimator implements FixedProductPriceEstimator<FixedPerUnitProduct> {
  estimate(product: FixedPerUnitProduct, contractDuration: undefined | number = FIXED_PER_UNIT_PRICE_ESTIMATOR_DEFAULT_CONTRACT_DURATION): number {
    const price = product.variants[0].pricing.priceConfiguration.price;
    const units = product.variants[0].pricing.priceConfiguration.units;
    const totalPrice = price * units;
    const isUpfrontPay = product.variants[0].pricing.priceConfiguration.upfrontPay;

    return isUpfrontPay ? totalPrice * contractDuration : totalPrice;
  }
}